export default __webpack_public_path__ + "img/favicon.a56ecf01.ico";